import React from "react"

import { AppCrudTable } from "@components"
import { userSettingProvidersData } from "../../../@signals"
import { actionsColumn, colorColumn, nameColumn } from "./columns"
import { isTourDemoActive } from "@signals/app"

export default function UserSettingsColorProvidersTable() {
	if (isTourDemoActive.value && !userSettingProvidersData.value?.length) return null
	return <AppCrudTable
		title="Provider Colors"
		data={userSettingProvidersData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}